module.exports = __webpack_public_path__ + "static/media/sliderEnd.0aa43708.mp3";